import payment from '@/api/payment-testing'
import feeSetup from '@/api/fee-setup'
import subProgram from '@/api/sub-program'
import inquiry from '@/api/info-inquiry'
import term from '@/api/term-semester'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  subPrograms: [],
  feeSetupLists: [],
  branch_id: null,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_SUB_PROGRAM(state, subProgram) {
    state.subPrograms = subProgram
  },
  SET_FEE_SETUP(state, feeSetupList) {
    state.feeSetupLists = feeSetupList
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return payment.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return payment.store(data)
  },

  update(context, { id, data }) {
    return payment.update(id, data)
  },
  destroy(context, { id, data }) {
    return payment.destroy(id, data)
  },
  printPdf(context, id) {
    return payment.pdf(id)
  },
  formViewModel(context, Options) {
    return payment.formViewModel({ params: Options })
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await payment.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async getFeeSetup(context, searchValue) {
    let response = await feeSetup.get({
      params: {
        fields: {
          setup_payment_fee_setups:
            'fee_type_id,fee_setup_id,fee_name_en,fee_amount'
        },
        filter: {
          fee_type_id: 6 // only for other fee
        },
        search: searchValue,
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_FEE_SETUP', response.data)
    return response
  },
  async getSubProgram(context) {
    let response = await subProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acps_id,acps_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
    context.commit('SET_SUB_PROGRAM', response.data)
    return response
  },
  getInquiry(context, searchValue) {
    return inquiry.get({
      params: {
        include: 'sub_program,study_time',
        filter: {
          is_registered: false
        },
        search: searchValue,
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTermBySub(context, acpsId) {
    return term.get({
      params: {
        fields: {
          academic_terms: 'ac_term_id,term_name,ac_year_id'
        },
        filter: {
          acps_id: acpsId
        },
        page: -1
      }
    })
  }
}
